import React from 'react'
import { withSnackbar } from 'notistack';
import Service from '../../config/networkutils';
import { Box, Button, CircularProgress, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Tooltip, Typography } from '@material-ui/core';
import UploadIcon from '@material-ui/icons/CloudUpload'
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import XLSX from "xlsx";
import Modal from '../../shared/Modal/Modal';
import Dropzone from '../../shared/Dropzone/Dropzone';
import { getCookie } from '../../utils/CookieHelper';
import { getDataIsdeletedFalse } from '../Helper/CommonThings';
import GateStageLink from './GateStageLink';

const token = getCookie("ptd_ts_token");
const user = JSON.parse(getCookie("ptd_ts_user"))

class CRMInputTable extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            columns: this.props.columns,
            data: [],
            isLoading: false,
            dropZoneModal: false,
            reviewModal: false,
            dataToUpload: [],
            bulkUploadLoader: false,
            searchText: '',
            sortBy: '',
            sortDirection: 'asc',
            formDialogOpen: false,
            isSaving: false,
            formData: {},
            editingRow: null,
            deleteDialogOpen: false,
            isDeleting: false,
            deletingRow: null,
            expandedRowId: null
        }
    }

    componentDidMount() {
        if (this.props.data) {
            this.setState({ data: getDataIsdeletedFalse(this.props.data) })
        }
    }

    fetchOps() {
        this.setState({ isLoading: true })

        let api = '/api/ptd/account/get_crm_inputs_data/'
        let filter = ''
        if (this.props.tableName === 'Client Name') {
            api += '?client=true'
            filter = 'client'
        } else if (this.props.tableName === 'Sales Stage') {
            api += '?sales_stage=true'
            filter = 'sales_stage'
        } else if (this.props.tableName === 'Gate Stages') {
            api += '?gate_stage=true'
            filter = 'gate_stage'
        } else if (this.props.tableName === 'Discipline') {
            api += '?discipline=true'
            filter = 'discipline'
        } else if (this.props.tableName === 'Division') {
            api += '?division=true'
            filter = 'division'
        } else if (this.props.tableName === 'Operations Lead') {
            api += '?operations_lead=true'
            filter = 'operations_lead'
        } else if (this.props.tableName === 'Sub Division') {
            api += '?sub_division=true'
            filter = 'sub_division'
        } else if (this.props.tableName === 'Opportunity Type') {
            api += '?opportunity_type=true'
            filter = 'opportunity_type'
        } else if (this.props.tableName === 'Payrole Process') {
            api += '?payrole_process=true'
            filter = 'payrole_process'
        } else if (this.props.tableName === 'Distribution Type') {
            api += '?distribution_type=true'
            filter = 'distribution_type'
        }else if (this.props.tableName === 'Archive Reason') {
            api += '?emp_archive_reason=true'
            filter = 'emp_archive_reason'
        }

        Service.get(api, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({
                    data: getDataIsdeletedFalse(res.data[filter]),
                    isLoading: false
                })
            })
            .catch(error => {
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error',
                });
            });
    }


    postOps(data) {
        if (!data.name) {
            this.setState({ isLoading: true, })
            setTimeout(() => {
                this.setState({ isLoading: false, })
                // this.fetchOps();
                this.props.enqueueSnackbar('Name field is empty!', {
                    variant: 'error'
                });
            }, 200)

        } else {
            let api = ''
            if (this.props.post_api) {
                api = this.props.post_api
            } else if (this.props.api.includes('get_with_delete_status/')) {
                api = this.props.api.replace('get_with_delete_status/', '')
            } else if (this.props.api.includes('get_sales_stage_data/')) {
                api = this.props.api.replace('get_sales_stage_data/', '')
            } else if (this.props.api.includes('get_gate_stage_data/')) {
                api = this.props.api.replace('get_gate_stage_data/', '')
            } else if (this.props.api.includes('get_opportunity_type_data/')) {
                api = this.props.api.replace('get_opportunity_type_data/', '')
            } else if (this.props.api.includes('get_market_subvertical_data/')) {
                api = this.props.api.replace('get_market_subvertical_data/', '')
            } else if (this.props.api.includes('get_pay_role_data/')) {
                api = this.props.api.replace('get_pay_role_data/', '')
            } else {
                api = this.props.api
            }
            data.created_by = user.id
            return Service.post(api, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: data,
            })
                .then(res => {
                    this.fetchOps();
                    this.props.enqueueSnackbar('Field added successfully', {
                        variant: 'success'
                    });
                    return true;
                })
                .catch(error => {
                    console.log(error)
                    this.setState({ isLoading: false })
                    this.props.enqueueSnackbar('Something went wron!', {
                        variant: 'error'
                    });
                    return false;
                })
        }
    }

    putOps(data) {
        if (!data.name) {
            this.setState({ isLoading: true, })
            setTimeout(() => {
                this.setState({ isLoading: false, })
                // this.fetchOps();
                this.props.enqueueSnackbar('Name field is empty!', {
                    variant: 'error'
                });
            }, 200)

        } else {
            let api = ''
            if (this.props.api.includes('get_with_delete_status/')) {
                api = this.props.api.replace('get_with_delete_status/', '')
            } else if (this.props.api.includes('get_sales_stage_data/')) {
                api = this.props.api.replace('get_sales_stage_data/', '')
            } else if (this.props.api.includes('get_gate_stage_data/')) {
                api = this.props.api.replace('get_gate_stage_data/', '')
            } else if (this.props.api.includes('get_opportunity_type_data/')) {
                api = this.props.api.replace('get_opportunity_type_data/', '')
            } else if (this.props.api.includes('get_market_subvertical_data/')) {
                api = this.props.api.replace('get_market_subvertical_data/', '')
            } else if (this.props.api.includes('get_pay_role_data/')) {
                api = this.props.api.replace('get_pay_role_data/', '')
            } else {
                api = this.props.api
            }
            data.created_by = user.id
            return Service.put(api + data.id + '/', {
                headers: {
                    Authorization: "Token " + token,
                },
                data: {
                    name: data.name,
                    created_by: data.created_by
                },
            })
                .then(res => {
                    this.fetchOps()
                    this.props.enqueueSnackbar('Field updated successfully', {
                        variant: 'success'
                    });
                    return true;
                })
                .catch(error => {
                    this.setState({ isLoading: false })
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                    this.fetchOps();
                    return false;
                });
        }
    }

    deleteOps(data) {
        let api = ''
        if (this.props.api.includes('get_with_delete_status/')) {
            api = this.props.api.replace('get_with_delete_status/', '')
        } else if (this.props.api.includes('get_sales_stage_data/')) {
            api = this.props.api.replace('get_sales_stage_data/', '')
        } else if (this.props.api.includes('get_gate_stage_data/')) {
            api = this.props.api.replace('get_gate_stage_data/', '')
        } else if (this.props.api.includes('get_opportunity_type_data/')) {
            api = this.props.api.replace('get_opportunity_type_data/', '')
        } else if (this.props.api.includes('get_market_subvertical_data/')) {
            api = this.props.api.replace('get_market_subvertical_data/', '')
        } else if (this.props.api.includes('get_pay_role_data/')) {
            api = this.props.api.replace('get_pay_role_data/', '')
        } else {
            api = this.props.api
        }
        return Service.delete(api + data.id + "/", {
            headers: {
                Authorization: "Token " + token,
            }
        })
            .then(res => {
                this.fetchOps()
                this.props.enqueueSnackbar('Deleted successfully', {
                    variant: 'success'
                });
                return true;
            })
            .catch(error => {
                this.setState({ isLoading: false })
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
                this.fetchOps();
                return false;
            });
    }

    bulkPost(data) {
        Service.post(this.props.api, {
            headers: {
                Authorization: "Token " + token,
            },
            data
        })
            .then(res => {
                this.props.enqueueSnackbar(res.data.length + (res.data.length === 1 ? 'Row' : ' Rows') + ' added successfully', {
                    variant: 'success'
                })
            })
            .catch(e => {
                console.error(e)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })

    }

    bulkUpdate(data) {
        Service.patch(this.props.bulk_update_api, {
            headers: {
                Authorization: "Token " + token,
            },
            data
        })
            .then(res => {

                this.props.enqueueSnackbar(res.data.length + (res.data.length === 1 ? 'Row' : ' Rows') + ' updated successfully', {
                    variant: 'success'
                });

            })
            .catch(e => {

                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })

    }

    reviewModalOpen = () => { this.setState({ reviewModal: true }) }

    reviewModalClose = () => { this.setState({ reviewModal: false }) }

    fileToRead(files) {
        if (!files || !files[0]) return;
        let f = files[0];
        try {
            const reader = new FileReader();
            const rABS = !!reader.readAsBinaryString;

            reader.onload = (e) => {
                /* read workbook */
                const bstr = e.target.result;
                const wb = XLSX.read(bstr, { type: 'binary' });

                /* grab first sheet */

                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];

                /* save data */
                const data = XLSX.utils.sheet_to_json(ws)


                this.setState({ dataToUpload: data })
            };
            if (rABS) {
                reader.readAsBinaryString(f);
            } else {
                reader.readAsArrayBuffer(f);
            }
        }
        catch (e) {
            console.error(e)
        }
    }

    bulkUpload = () => {

        this.setState({ bulkUploadLoader: true })

        let dataToUpload = [...this.state.dataToUpload]
        let dataToUpdate = []
        dataToUpload.forEach((ele, i) => {
            this.state.data.forEach(ele2 => {
                if (ele.name.toLowerCase() === ele2.name.toLowerCase()) {
                    ele.id = ele2.id;
                    dataToUpdate.push(ele)
                }
            })
        })
        dataToUpdate.forEach((ele) => {
            dataToUpload.forEach((ele2, i) => {
                if (ele.name.toLowerCase() === ele2.name.toLowerCase()) {
                    dataToUpload.splice(i, 1)
                }
            })
        })


        if (dataToUpload.length) {

            let arr = [];
            for (let i = 1; i <= dataToUpload.length; i++) {
                arr.push(dataToUpload[i - 1])
                if (i === 1000 * Number((i / 1000).toFixed())) {
                    this.bulkPost(arr)
                    arr = []
                }
                if (i === dataToUpload.length) {
                    this.bulkPost(arr)
                }
            }


        }
        if (dataToUpdate.length) {

            let arr = [];
            for (let i = 1; i <= dataToUpdate.length; i++) {
                arr.push(dataToUpdate[i - 1])
                if (i === 1000 * Number((i / 1000).toFixed())) {
                    this.bulkUpdate(arr)
                    arr = []
                }
                if (i === dataToUpdate.length && arr.length) {
                    this.bulkUpdate(arr)
                }
            }
        }

        setTimeout(() => {
            this.setState({
                reviewModal: false,
                dataToUpload: [],
                dropZoneModal: false,
                bulkUploadLoader: false
            })
            this.fetchOps()
        }, 4000);

    }

    dropzoneClose = () => {
        this.setState({ dropZoneModal: false })
    }

    openAddDialog = () => {
        this.setState({
            formDialogOpen: true,
            editingRow: null,
            formData: {}
        })
    }

    openEditDialog = (row) => {
        this.setState({
            formDialogOpen: true,
            editingRow: row,
            formData: { ...row }
        })
    }

    closeFormDialog = () => {
        this.setState({ formDialogOpen: false, editingRow: null, formData: {} })
    }

    saveRow = () => {
        if (this.state.isSaving) return;

        const name = (this.state.formData.name || '').trim();
        if (!name) {
            this.props.enqueueSnackbar('Name field is empty!', { variant: 'error' });
            return;
        }

        const data = { ...this.state.formData, name };
        this.setState({ isSaving: true });
        const saveRequest = this.state.editingRow ? this.putOps(data) : this.postOps(data);
        saveRequest.then(success => {
            if (success) this.closeFormDialog();
        }).finally(() => this.setState({ isSaving: false }));
    }

    openDeleteDialog = (row) => {
        this.setState({ deleteDialogOpen: true, deletingRow: row })
    }

    closeDeleteDialog = () => {
        this.setState({ deleteDialogOpen: false, deletingRow: null })
    }

    confirmDelete = () => {
        if (this.state.isDeleting || !this.state.deletingRow) return;

        this.setState({ isDeleting: true });
        this.deleteOps(this.state.deletingRow)
            .then(success => {
                if (success) this.closeDeleteDialog();
            })
            .finally(() => this.setState({ isDeleting: false }));
    }

    getVisibleData = () => {
        const searchText = this.state.searchText.trim().toLowerCase();
        const filteredData = this.state.data.filter(row => !searchText || this.state.columns.some(column => {
            const value = row[column.field];
            return value !== null && value !== undefined && String(value).toLowerCase().includes(searchText);
        }));

        if (!this.state.sortBy) return filteredData;
        const column = this.state.columns.find(item => item.field === this.state.sortBy);
        return filteredData.sort((left, right) => {
            const leftValue = left[this.state.sortBy];
            const rightValue = right[this.state.sortBy];
            const comparison = String(leftValue === null || leftValue === undefined ? '' : leftValue)
                .localeCompare(String(rightValue === null || rightValue === undefined ? '' : rightValue), undefined, { numeric: true, sensitivity: 'base' });
            return this.state.sortDirection === 'asc' ? comparison : -comparison;
        }).map(row => ({ ...row, _sortTitle: column && column.title }));
    }

    toggleSort = (field) => {
        this.setState(state => ({
            sortBy: field,
            sortDirection: state.sortBy === field && state.sortDirection === 'asc' ? 'desc' : 'asc'
        }));
    }

    renderCell = (column, row) => {
        if (column.render) return column.render(row);
        if (column.lookup && column.lookup[row[column.field]] !== undefined) return column.lookup[row[column.field]];
        return row[column.field] === null || row[column.field] === undefined ? '' : row[column.field];
    }

    render() {
        const access = this.props.access.access
        const canAdd = access.l2a && access.l2a.l2a_b;
        const canEdit = access.l2a && access.l2a.l2a_c;
        const canDelete = ((canAdd || canEdit) && this.props.deletable);
        const visibleData = this.getVisibleData();
        const formColumns = this.state.columns.filter(column => column.editable !== 'never');
        const hasActions = canEdit || this.props.deletable || this.props.detailPanel;
        const tableColumnCount = this.state.columns.length + (this.props.detailPanel ? 1 : 0) + (hasActions ? 1 : 0);

        const handleChange = event => {
            const { name, value } = event.target;
            this.setState(state => ({
                formData: { ...state.formData, [name]: value }
            }));
        }
        return (<>
            <Box>
                <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" mb={1}>
                    <Box display="flex" alignItems="center">
                        <Typography variant="h6">{this.props.tableName}</Typography>
                        {this.props.upload === true && <Tooltip title="Upload spreadsheet">
                            <IconButton size="small" style={{ marginLeft: 8 }} onClick={() => this.setState({ dropZoneModal: true })} aria-label="Upload spreadsheet">
                                <UploadIcon />
                            </IconButton>
                        </Tooltip>}
                    </Box>
                    <Box display="flex" alignItems="center">
                        <TextField
                            size="small"
                            label="Search"
                            value={this.state.searchText}
                            onChange={event => this.setState({ searchText: event.target.value })}
                            inputProps={{ 'aria-label': 'Search table' }}
                        />
                        {canAdd && <Tooltip title="Add row">
                            <IconButton size="small" onClick={this.openAddDialog} aria-label="Add row"><AddIcon /></IconButton>
                        </Tooltip>}
                    </Box>
                </Box>
                <TableContainer component={Paper}>
                    <Table size="small" aria-label={this.props.tableName}>
                        <TableHead>
                            <TableRow>
                                {this.props.detailPanel && <TableCell padding="checkbox" />}
                                {hasActions && <TableCell align="left" padding="none" width={60} maxWidth={60}>Actions</TableCell>}
                                {this.state.columns.map(column => <TableCell key={column.field} style={column.field === 'id' ? { width: 50, maxWidth: 50 } : undefined}>
                                    <TableSortLabel
                                        active={this.state.sortBy === column.field}
                                        direction={this.state.sortBy === column.field ? this.state.sortDirection : 'asc'}
                                        onClick={() => this.toggleSort(column.field)}
                                    >{column.title}</TableSortLabel>
                                </TableCell>)}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.isLoading && <TableRow><TableCell colSpan={tableColumnCount} align="center"><CircularProgress size={24} /></TableCell></TableRow>}
                            {!this.state.isLoading && visibleData.map((row, index) => {
                                const rowId = row.id === undefined ? index : row.id;
                                const isExpanded = this.state.expandedRowId === rowId;
                                return <React.Fragment key={rowId}>
                                    <TableRow hover>
                                        {this.props.detailPanel && <TableCell padding="checkbox">
                                            <Tooltip title={isExpanded ? 'Hide details' : 'Show details'}>
                                                <IconButton
                                                    size="small"
                                                    onClick={() => this.setState({ expandedRowId: isExpanded ? null : rowId })}
                                                    aria-label={isExpanded ? 'Hide details' : 'Show details'}
                                                >
                                                    {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>}
                                        {hasActions && <TableCell align="left" padding="none" width={60} maxWidth={60}>
                                            {canEdit && <Tooltip title="Edit row"><IconButton size="small" onClick={() => this.openEditDialog(row)} aria-label="Edit row"><EditIcon fontSize="small" /></IconButton></Tooltip>}
                                            {this.props.deletable && <Tooltip title="Delete row"><span><IconButton size="small" onClick={() => this.openDeleteDialog(row)} disabled={!canDelete || !row.is_deletable} aria-label="Delete row"><DeleteIcon fontSize="small" /></IconButton></span></Tooltip>}
                                        </TableCell>}

                                        {this.state.columns.map(column => <TableCell key={column.field} style={column.field === 'id' ? { width: 50, maxWidth: 50 } : undefined}>{this.renderCell(column, row)}</TableCell>)}
                                    </TableRow>
                                    {this.props.detailPanel && <TableRow>
                                        <TableCell colSpan={tableColumnCount} style={{ padding: 0, borderBottom: isExpanded ? undefined : 0 }}>
                                            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                                                <Box p={2} bgcolor="#f5f5f5">
                                                    <GateStageLink gateStage={this.props.gateStage} salesStage={this.props.salesStage} stage={row} get_api={this.props.link_get_api} post_api={this.props.link_post_api} />
                                                </Box>
                                            </Collapse>
                                        </TableCell>
                                    </TableRow>}
                                </React.Fragment>
                            })}
                            {!this.state.isLoading && visibleData.length === 0 && <TableRow><TableCell colSpan={tableColumnCount} align="center">No records to display</TableCell></TableRow>}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>

            <Dialog open={this.state.formDialogOpen} onClose={this.closeFormDialog} fullWidth maxWidth="xs">
                <DialogTitle>{this.state.editingRow ? 'Edit' : 'Add'} {this.props.tableName}</DialogTitle>
                <DialogContent>
                    {formColumns.map(column => <TextField
                        // variant='outlined'
                        key={column.field}
                        autoFocus={column.field === 'name'}
                        name={column.field}
                        margin="dense"
                        fullWidth
                        label={column.title}
                        value={this.state.formData[column.field] || ''}
                        onChange={handleChange}
                        disabled={column.editable === 'never'}
                    />)}
                </DialogContent>
                <DialogActions>
                    <Button size="small" onClick={this.closeFormDialog}>Cancel</Button>
                    <Button size="small" color="primary" variant="contained" onClick={this.saveRow} disabled={this.state.isSaving}>Save</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={this.state.deleteDialogOpen} onClose={this.closeDeleteDialog} maxWidth="xs" fullWidth>
                <DialogTitle>Confirm delete</DialogTitle>
                <DialogContent><DialogContentText>Are you sure you want to delete "{this.state.deletingRow ? this.state.deletingRow.name : ''}"?.</DialogContentText></DialogContent>
                <DialogActions>
                    <Button size="small" onClick={this.closeDeleteDialog} disabled={this.state.isDeleting}>Cancel</Button>
                    <Button size="small" color="secondary" variant="contained" onClick={this.confirmDelete} disabled={this.state.isDeleting}>Delete</Button>
                </DialogActions>
            </Dialog>

            <Dropzone
                open={this.state.dropZoneModal}
                onClose={this.dropzoneClose}
                onChange={(e) => this.fileToRead(e)}
                preview={this.reviewModalOpen}
            />

            <Modal
                open={this.state.reviewModal}
                close={this.reviewModalClose}
                onUpload={this.bulkUpload}
                columns={this.state.columns}
                data={this.state.dataToUpload}
                loading={this.state.bulkUploadLoader}
                title={this.props.tableName}
            />
        </>)
    }
}

export default withSnackbar(CRMInputTable)